import React, { useState } from "react";
import Typed from "react-typed";
import { ArrowSmDownIcon } from "@heroicons/react/outline";
import pdf from "../../Image/Deepesh.pdf";
const TextIntroduction = () => {
  const [animate, setAnimate] = useState();
  const onButtonClick = () => {
    let data;
    setTimeout(() => {
      // using Java Script method to get PDF file
      data = fetch(pdf).then((response) => {
        response.blob().then((blob) => {
          // Creating new object of PDF file
          const fileURL = window.URL.createObjectURL(blob);
          // Setting various property values
          let alink = document.createElement("a");
          alink.href = fileURL;
          alink.download = "Resume.pdf";
          alink.click();
        });
      });
      setAnimate(false);
    }, 1000);
    if (!data) {
      return <>{setAnimate(true)}</>;
    }
  };
  return (
    <>
      <div className="  md:container md:mt-[100px]">
        <div className="md:flex md:justify-center ">
          <h2
            className="text-3xl uppercase font-bold  md:text-[64px]  text-[#17A6DB] dark:text-[#30dada]   [text-shadow:_4px_4px_#000] dark:[text-shadow:_4px_4px_#FFF]"
          
          >
            Hi
          </h2>
        </div>
        <div className="md:flex md:justify-center md:pt-8 pb-8 ">
          <h2
            className="text-3xl uppercase e font-sans md:text-[64px] text-[#17A6DB] dark:text-[#30dada]  [text-shadow:_4px_4px_#000] dark:[text-shadow:_4px_4px_#FFF]"
         
          >
            I Am Deepesh
          </h2>
        </div>
        <div className="md:flex md:justify-center ">
          <Typed
            className="text-3xl uppercase font-bold   font-sans  md:text-[64px]  dark:text-white [text-shadow:_4px_4px_#17A6DB]  dark:[text-shadow:_4px_4px_#30dada] "
            strings={["FrontEnd Developer"]}
            typeSpeed={120}
            backSpeed={140}
            loop
         
          />
        </div>
        <div className="my-6  md:flex md:justify-center  md:m-12">
          <button
            onClick={onButtonClick}
            className="py-3 px-14 flex text-lg font-normal dark:first:text-white  border-[4px] border-[#17A6DB] dark:border-[#30dada] rounded-[48px] shadow-[40px] duration-200 bg-gradient-to-r from-green-400 to-blue-500 hover:from-pink-500 hover:to-yellow-500    md:text-3xl"
          >
         {  animate?"Downloading..."  :"Download Resume"}
            <ArrowSmDownIcon
              className={
                animate
                  ? " down-arrow w-6 md:w-10 ml-2 text-[#172b33] dark:text-[#043d3d] "
                  : "  w-6 md:w-10 ml-2 text-[#172b33] dark:text-[#043d3d]  "
              }
            />
          </button>
        </div>
      </div>
    </>
  );
};

export default TextIntroduction;
